__turbopack_context__.v({
  "className": "rijksfont_67b3477a-module__4N5Ewa__className",
});
